import { createContext, useContext, useEffect, useState } from "react";
import { t } from "@/lib/i18n";

const LangContext = createContext({ lang: "pt", setLang: () => {}, tr: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem("lama_lang") || "pt";
  });
  useEffect(() => {
    localStorage.setItem("lama_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const value = {
    lang,
    setLang: setLangState,
    tr: (path) => t(lang, path),
  };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
